import { useTranslation } from 'react-i18next';

export const keyPrefix = 'checkGroupAvailability';
export const useCheckGroupAvailabilityTranslation = () => useTranslation('entities', { keyPrefix });

export const ruRu = ({
  [keyPrefix]: {
    details: 'Группа «{{groupName}}» уже прикреплена к тегу «{{permissionTag}}». После добавления она будет откреплена от него. Вы уверены?',
    title: 'Добавление группы',
    reject: 'Отмена',
    confirm: 'Добавить',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    details: 'Group "{{groupName}}" already belongs to permission tag "{{permissionTag}}". After adding it here, it will be detached from the old tag. Continue?',
    title: 'Add group',
    reject: 'Cancel',
    confirm: 'Add',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    details: 'El grupo «{{groupName}}» ya está vinculado a la etiqueta de acceso «{{permissionTag}}». Después de agregarlo aquí, será desvinculado de la etiqueta anterior. ¿Continuar?',
    title: 'Agregar grupo',
    reject: 'Cancelar',
    confirm: 'Agregar',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    details: 'O grupo «{{groupName}}» já está vinculado à tag de permissão «{{permissionTag}}». Após adicioná-lo aqui, ele será desvinculado da tag anterior. Deseja continuar?',
    title: 'Adicionar grupo',
    reject: 'Cancelar',
    confirm: 'Adicionar',
  },
}) as Record<string, unknown>;
